import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function setReview(review) {
  const sliderEl = review.querySelector('.js-review__slider');
  const pagination = review.querySelectorAll('.js-review__pagination .review__pagination__item');

  if (!sliderEl) return;

  const slides = sliderEl.querySelectorAll('.swiper-slide');

  if (slides.length < 2) return;

  // eslint-disable-next-line no-new
  new Swiper(sliderEl, {
    effect: 'fade',
    speed: 3000,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    on: {
      slideChange(swiper) {
        pagination.forEach((item, index) => {
          item.classList.toggle('is-active', index === swiper.realIndex);
        });
      },
    },
  });
}

document.querySelectorAll('.js-review').forEach(setReview);
